import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=dcba55e4&scoped=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=dcba55e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba55e4",
  null
  
)

export default component.exports